export const asyncTypes = action => ({
  ORIGIN: action,
  SUCCESS: `${action}_SUCCESS`,
  FAILURE: `${action}_FAILURE`,
  CLEAR: `${action}_CLEAR`,
  REQUEST: `${action}_REQUEST`,
})

export default { asyncTypes }
